<kendo-dialog title="{{title}}" [minWidth]="200" [width]="350">
  <p class="k-dialog-content">{{question}}</p>

  <div *ngIf="furtherInfo != undefined">
    <table>
      <tbody>
      <tr *ngFor="let info of furtherInfo">
        <td>
          {{ info }}
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <table cellspacing="10" style="margin: auto;">
    <tbody>
    <tr>
      <td>
        <button kendoButton (click)="yes()" primary="true">Yes</button>
      </td>
      <td>
        <button kendoButton (click)="no()">No</button>
      </td>
    </tr>
    </tbody>
  </table>
</kendo-dialog>
